import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraShutterFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m16.41 11-4.64-8.35A14 14 0 0 0 2.94 11Zm3.17 8h10.09a14 14 0 0 0 .33-3 13.92 13.92 0 0 0-3.15-8.84Zm.76-5.06 5.08-8.28A14 14 0 0 0 16 2a14.5 14.5 0 0 0-2.2.19ZM15.12 21l4.72 8.45A14 14 0 0 0 29.06 21ZM11 17.68l-5 8.06A13.9 13.9 0 0 0 16 30a13 13 0 0 0 1.78-.13Zm.54-4.68H2.33A14 14 0 0 0 2 16a13.9 13.9 0 0 0 2.61 8.12Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCameraShutterFilledSVG);
ForwardRef.displayName = "IconCameraShutterFilled";
export { ForwardRef as IconCameraShutterFilled };
